/* eslint-disable jira/filename-case, jira/react-magnetic-di/no-unneeded, jira/naming/disallow-filenames */
import { di } from 'react-magnetic-di';
import type { RouteResourceError } from '@atlassian/react-resource-router';

const isDataEmpty = <D,>(data: D) => data == null;

export type FetchResult<TData> = {
	data: TData | null;
	loading: boolean;
	error: RouteResourceError | null;
};

export function withThrowOnError<
	TArgs extends Array<unknown>,
	TResult extends FetchResult<TData>,
	TData,
>(theHook: (...args: TArgs) => TResult): (...args: TArgs) => TResult {
	return (...args: TArgs) => {
		// tests like src/packages/navigation-apps/horizontal-nav/tabs/board-scoped-tab/src/test.tsx do not work without this line
		di(theHook);
		const result = theHook(...args);
		// escalate .error if condition is met (by throwing a runtime exception from it; to be caught and logged by the nearest ErrorBoundary for example).
		if (!__SERVER__ && isDataEmpty(result.data) && !result.loading && result.error) {
			throw result.error;
		}
		return result;
	};
}
